module.exports = __webpack_public_path__ + "static/media/photo3.56d45ee7.jpg";